import React, { Component } from 'react'
import GamesList from './GamesList'

export default class Games extends Component{
    constructor(){
        super()
    }

    render(){
        return(
            <div className="row">
                <article className="col-xs-12">
                    <div className="jarviswidget" id="wid-id-0" data-widget-editbutton="false">
                        <header>
                            <span className="widget-icon"> <i className="fa fa-gear"></i> </span>
                            <h2><strong>Lotto</strong> <i>Games</i></h2>
                        </header>
                        <div>
                            <div className="jarviswidget-editbox"></div>
                            <div id="gameCon" className="widget-body">
                                <GamesList />
                            </div>                            
                        </div>
                    </div>
                </article>
            </div>
        )
    }
}